import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const AnnouncementIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8889 16.2059V16.6765C11.8889 17.885 11.8889 18.4893 11.6898 18.8304C11.4243 19.2853 10.9388 19.5424 10.4358 19.4943C10.0586 19.4583 9.60204 19.0957 8.68889 18.3706L7.62222 17.5235C6.75336 16.8336 6.55556 16.4146 6.55556 15.2647V13.8529M7 13.3824V7.73529M13.6012 4.35744L7.68757 7.36308C7.23245 7.59439 6.74616 7.65235 6.25044 7.53476C5.92602 7.45781 5.76379 7.41933 5.63316 7.40354C4.01105 7.20741 3 8.56675 3 10.1299V10.9877C3 12.5509 4.01105 13.9103 5.63316 13.7141C5.76379 13.6983 5.92603 13.6598 6.25044 13.5829C6.74616 13.4653 7.23245 13.5232 7.68757 13.7546L13.6012 16.7602C14.9586 17.4502 15.6373 17.7952 16.3941 17.5263C17.1508 17.2574 17.4106 16.6803 17.9301 15.5264C19.3566 12.3576 19.3566 8.76009 17.9301 5.59126C17.4106 4.43728 17.1508 3.86029 16.3941 3.59139C15.6373 3.32249 14.9586 3.66747 13.6012 4.35744Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};
